import { getAppEnv } from './config/env';

const CLOUD_NAME = getAppEnv('REACT_APP_CLOUDINARY_CLOUD_NAME');
const UPLOAD_PRESET = getAppEnv('REACT_APP_CLOUDINARY_UPLOAD_PRESET');
const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;
const VIDEO_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`;
const DESTROY_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/destroy`;

export async function uploadImage(file) {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error('Cloudinary config missing. Check REACT_APP_CLOUDINARY_CLOUD_NAME and REACT_APP_CLOUDINARY_UPLOAD_PRESET in .env');
  }
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', 'umi-blog');

  console.log('Cloudinary upload ->', { cloudName: CLOUD_NAME, preset: UPLOAD_PRESET });
  const res = await fetch(UPLOAD_URL, { method: 'POST', body: formData });
  if (!res.ok) {
    const errorBody = await res.text();
    console.error('Cloudinary error response:', res.status, errorBody);
    throw new Error(`Image upload failed: ${res.status}. Make sure your Cloudinary upload preset "${UPLOAD_PRESET}" is set to "Unsigned" in your Cloudinary dashboard (Settings -> Upload -> Upload presets).`);
  }
  const data = await res.json();
  return { url: data.secure_url, publicId: data.public_id };
}

export async function uploadVideo(file) {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error('Cloudinary config missing. Check REACT_APP_CLOUDINARY_CLOUD_NAME and REACT_APP_CLOUDINARY_UPLOAD_PRESET in .env');
  }
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', 'umi-blog/videos');

  const res = await fetch(VIDEO_UPLOAD_URL, { method: 'POST', body: formData });
  if (!res.ok) {
    const errorBody = await res.text();
    console.error('Cloudinary video error response:', res.status, errorBody);
    throw new Error(`Video upload failed: ${res.status}. Check that your Cloudinary upload preset "${UPLOAD_PRESET}" allows unsigned video uploads and that the video is within your plan limits.`);
  }
  const data = await res.json();
  return { url: data.secure_url, publicId: data.public_id };
}

export async function deleteImage(publicId) {
  if (!publicId) return;
  // Note: unsigned deletes require enabling in Cloudinary settings.
  // If not enabled, images can be managed via the Cloudinary dashboard.
  try {
    const formData = new FormData();
    formData.append('public_id', publicId);
    formData.append('upload_preset', UPLOAD_PRESET);
    await fetch(DESTROY_URL, { method: 'POST', body: formData });
  } catch (err) {
    console.warn('Cloudinary delete skipped (manage via dashboard):', err.message);
  }
}
